import { render, staticRenderFns } from "./shop-rec.vue?vue&type=template&id=fba2808a&scoped=true"
import script from "./shop-rec.vue?vue&type=script&lang=js"
export * from "./shop-rec.vue?vue&type=script&lang=js"
import style0 from "./shop-rec.vue?vue&type=style&index=0&id=fba2808a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba2808a",
  null
  
)

export default component.exports